import { css } from '@emotion/react';

export const btnBaseStyles = css({
  minWidth: '100px',
});
